"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _RescheduleComponent = _interopRequireDefault(require("../RescheduleComponent"));
var _styles = require("./styles");
var _xstate2 = require("../../lib/constants/xstate");
var _messages = _interopRequireDefault(require("../../lib/messages"));
const ConfirmationPage = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    createRescheduleLink,
    searchProvidersLink,
    service,
    track
  } = _ref;
  const [currentState] = (0, _react2.useService)(service);
  const canceledPreviously = currentState.matches(_xstate2.states.canceledPreviously);
  const {
    appointment,
    locationId,
    locations,
    provider,
    providerId
  } = currentState.context;
  const headingMessage = canceledPreviously ? _messages.default.previouslyCanceledPageHeading : _messages.default.confirmPageHeading;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_styles.HeadingContainer, null, canceledPreviously ? /*#__PURE__*/_react.default.createElement(_styles.ErrorCircleStyled, {
    "aria-hidden": "true"
  }) : /*#__PURE__*/_react.default.createElement(_styles.CheckCircleStyled, {
    "aria-hidden": "true"
  }), /*#__PURE__*/_react.default.createElement(_styles.ConfirmHeading, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, headingMessage))), /*#__PURE__*/_react.default.createElement(_RescheduleComponent.default, {
    appointment: appointment,
    createRescheduleLink: createRescheduleLink,
    locationId: locationId,
    locations: locations,
    provider: provider,
    providerId: providerId,
    searchProvidersLink: searchProvidersLink,
    service: service,
    track: track
  }));
});
ConfirmationPage.displayName = 'ConfirmationPage';
ConfirmationPage.propTypes = {
  /**
   * Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment
   * @callback createRescheduleLink
   * @param {number} providerId
   * @param {string} patientRelationship
   * @param {string} patientPurpose
   */
  createRescheduleLink: _propTypes.func.isRequired,
  /**
   * URL link for the `Search Providers` button.
   */
  searchProvidersLink: _propTypes.string.isRequired,
  /**
   * The interpreted appointment cancel state machine
   */
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  /**
   * Callback triggered for tracking
   * @callback track
   * @param {string} eventName
   * @param {object} eventData
   */
  track: _propTypes.func.isRequired
};
var _default = exports.default = ConfirmationPage;
ConfirmationPage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ConfirmationPage",
  "props": {
    "createRescheduleLink": {
      "description": "Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment\n@callback createRescheduleLink\n@param {number} providerId\n@param {string} patientRelationship\n@param {string} patientPurpose",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "searchProvidersLink": {
      "description": "URL link for the `Search Providers` button.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "service": {
      "description": "The interpreted appointment cancel state machine",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "Callback triggered for tracking\n@callback track\n@param {string} eventName\n@param {object} eventData",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};